/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'auth-match-attribute-readonly';
const prefix = `${moduleName}.${componentName}`;

export const authAttributeMatchLabel = `${prefix}.authAttributeMatchLabel`;
export const memberLabel = `${prefix}.memberLabel`;
export const notMemberLabel = `${prefix}.notMemberLabel`;
export const anyLabel = `${prefix}.anyLabel`;

export const ENGLISH = {
    [authAttributeMatchLabel]: 'Attribute',
    [memberLabel]: 'Member',
    [notMemberLabel]: 'Not a Member',
    [anyLabel]: 'Any',
};
